import 'core-js/stable/parse-float';
import './gtag';
